import {
  Box,
  Button,
  Flex,
  Heading,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

interface JobListingCardProps {
  job_designation: string;
  location: string;
  job_type: string;
  workplace_type: string;
  job_summary: string;
  slug: string;
}

const JobListingCard: React.FC<JobListingCardProps> = ({
  location,
  job_type,
  job_designation,
  workplace_type,
  job_summary,
  slug,
}) => (
  <Flex
    w="100%"
    flexDir="column"
    border="1px solid #EDEDED"
    boxShadow="lg"
    pos="relative"
    borderRadius="7px"
    bg="white"
    py="24px"
    px="32px"
  >
    <Heading color="#3d3d5f" fontSize="20px">
      {job_designation}
    </Heading>
    <Flex
      mt="22px"
      w="100%"
      justifyContent="space-between"
      flexDirection={{ xs: 'column', md: 'row' }}
      gap="14px"
    >
      <Box>
        <Flex alignItems="center" w="100%" gap="22px">
          <Text
            fontWeight="600"
            fontSize={{ xs: '12px', md: '14px' }}
            lineHeight="150%"
            color="#232343"
            textAlign="left"
          >
            {location}
          </Text>
          <UnorderedList>
            <ListItem
              fontWeight="600"
              fontSize={{ xs: '12px', md: '14px' }}
              lineHeight="150%"
              color="#232343"
              textAlign="left"
            >
              {job_type}
            </ListItem>
          </UnorderedList>
          <UnorderedList>
            <ListItem
              fontWeight="600"
              fontSize={{ xs: '12px', md: '14px' }}
              lineHeight="150%"
              color="#232343"
              textAlign="left"
            >
              {workplace_type}
            </ListItem>
          </UnorderedList>
        </Flex>
        <Box mt="22px" w={{ xs: '100%', lg: '75%' }}>
          <Text
            textColor="#3D3D5F"
            opacity="75%"
            fontSize="14px"
            fontWeight="500"
          >
            {job_summary}
          </Text>
        </Box>
      </Box>
      <Link href={`/jobs/${slug}`}>
        <Button
          rightIcon={<FiArrowUpRight size="15px" color="#56B6A5" />}
          py="13px"
          pl="24px"
          variant="outline"
          color="text.textViolet"
          fontSize="14px"
          fontWeight="700"
          lineHeight="21px"
          letterSpacing="0.02em"
          borderRadius="0px"
          borderWidth="1.5px"
          h="44px"
        >
          View Job
        </Button>
      </Link>
    </Flex>
  </Flex>
);

export default JobListingCard;
